<template>
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Checkout</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <router-link :to="{name : 'Home'}">Home</router-link>
          </li>
          <li class="is-marked">
            <a href="checkout.html">Checkout</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <Spinner text="Please Wait" v-if="status.cart.loading" />
  <div style="height: 100px" v-if="ordersStatus.placeOrder.loading">
    <Spinner text="Redirecting" />
  </div>
  <Checkout
    v-if="
      !status.cart.loading &&
      !ordersStatus.placeOrder.loading &&
      getCarts.length != 0
    "
  />
  <div
    class="page-cart u-s-p-t-80"
    v-if="!status.cart.loading && getCarts.length == 0"
  >
    <div class="page-cart">
      <div class="">
        <div class="text-center">
          <h1>Em <i class="fas fa-child"></i>ty!</h1>
          <h5>Your cart is currently empty.</h5>
          <div class="redirect-link-wrapper u-s-p-t-25">
            <a class="redirect-link" href="/">
              <span>Return to Shop</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <RelatedProductsModal modal_id="related-products" />
  <Footer />
</template>

<script>
import Checkout from "../components/Checkout/Checkout.vue";
import Spinner from "../components/Loaders/Spinner.vue";
import Footer from "../components/Bottom/Footer.vue";
import RelatedProductsModal from "../components/Modals/RelatedProductsModal.vue"
import { mapGetters, mapActions } from "vuex";
export default {
  components: { Checkout, Spinner, Footer, RelatedProductsModal},
  computed: {
    ...mapGetters("cart", ["status", "getCarts"]),
    ...mapGetters("orders", ["ordersStatus"]),
    ...mapGetters("auth", ["isLoggedIn"]),
  },
};
</script>

<style>
</style>